import React from 'react';
import RocketList from '../components/RocketList/RocketList';

export default function Rockets() {
  return (
    <RocketList />
  );
}
